export default __webpack_public_path__ + "static/media/bolinhas.21180315.svg";